import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import { FaArrowRight } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import "./ContactForm.css";

const ContactForm = () => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      toast.error("Lütfen reCAPTCHA doğrulamasını yapın.");
      return;
    }

    const form = e.target;
    const data = {
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      message: form.message.value,
      recaptchaToken: recaptchaToken,
    };

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(data.email)) {
      toast.error("Geçerli bir e-posta adresi giriniz.");
      return;
    }

    try {
      const response = await fetch(
        process.env.REACT_APP_CONTACTFORM_GOOGLE_SCRIPT_URL,
        {
          method: "POST",
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (result.result === "success") {
        toast.success("Mesajınız başarıyla gönderildi.");
        form.reset();
        setRecaptchaToken(null);
        recaptchaRef.current.reset();
      } else {
        toast.error("Gönderim sırasında bir hata oluştu.");
      }
    } catch (error) {
      console.error("Hata:", error);
      toast.error("Sunucu hatası oluştu.");
    }
  };

  return (
    <div className="contact-form">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="form-group">
            <label htmlFor="name">İsim-Soyisim</label>
            <input type="text" id="name" name="name" placeholder="İsim Soyisim" required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Mail</label>
            <input type="email" id="email" name="email" placeholder="example@youremail.com" required />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Telefon</label>
          <input type="tel" id="phone" name="phone" placeholder="(555) 456 - 7890" required />
        </div>
        <div className="form-group">
          <label htmlFor="message">Mesaj</label>
          <textarea id="message" name="message" placeholder="Mesajınızı yazınız" required></textarea>
        </div>

        {/* reCAPTCHA */}
        <div className="contact-form-recaptcha-container">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={(token) => setRecaptchaToken(token)}
          />
        </div>

        <button type="submit" className="submit-button">
          Mesaj Gönder <FaArrowRight className="arrow-icon" />
        </button>
      </form>

      <ToastContainer position="bottom-center" autoClose={3000} />
    </div>
  );
};

export default ContactForm;
